import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Grid from "@material-ui/core/Grid";

const style = {
  grid: {
    padding: "0 15px !important",
  },
  dense: {
    paddingLeft: 0,
    paddingRight: 0
  }
};

function GridItem({ ...props }) {
  const { classes, children, dense, ...rest } = props;

  return (
    <Grid item {...rest} className={classes.grid + (dense ? classes.dense : '')}>
      {children}
    </Grid>
  );
}

export default withStyles(style)(GridItem);
